import { isArray } from 'util';
import { OperatorGroup } from '../operator-group';
import { OperatorBuilder } from './operator.builder';

export class OperatorGroupBuilder {
  static fromJson(json) {
    return (json)
      ? new OperatorGroup(
        json.hash,
        json.name,
        json.workingModelGroupHash,
        json.workingModelGroupName,
        OperatorBuilder.fromList(json.operators),
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(OperatorGroupBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/operator-group.builder.ts